import styled from '@emotion/styled';

export const ChatOrderProductCandidatesModalStyle = styled.div`
  position: relative;
  padding: 32px;
  width: 480px;
  border-radius: 16px;
  background-color: var(--seed-semantic-color-paper-default);
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  .close-button {
    position: absolute;
    top: 14px;
    right: 20px;
    padding: 3px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--seed-scale-color-gray-600);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: var(--seed-scale-color-gray-900);
    }

    svg {
      fill: var(--seed-scale-color-gray-600);
    }
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--seed-scale-color-gray-900);
  }

  .info-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background-color: var(--seed-scale-color-gray-100);
    border-radius: 8px;
    margin: 0 0 32px;

    .info-icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .info-text {
      font-size: 13px;
      line-height: 1.5;
      color: var(--seed-scale-color-gray-700);
    }
  }

  .product-list {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 16px;
  }

  .product-card {
    padding: 16px 0;

    &:not(:last-child) {
      border-bottom: 1px solid var(--seed-semantic-color-divider-1);
    }
  }

  .product-header {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;

    .product-radio {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid var(--seed-scale-color-gray-400);
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;

      &.selected {
        border-color: var(--seed-scale-color-gray-900);

        &::after {
          content: '';
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: var(--seed-scale-color-gray-900);
        }
      }
    }

    .product-thumbnail {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      object-fit: cover;
      border: 1px solid var(--seed-scale-color-gray-100);
    }

    .product-info {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .product-name {
        font-size: 15px;
        font-weight: 600;
        color: var(--seed-scale-color-gray-900);
      }

      .product-price {
        font-size: 15px;
        font-weight: 700;
        color: var(--seed-scale-color-gray-900);

        &.no-price {
          color: var(--seed-scale-color-gray-900);
          font-weight: 700;
        }
      }
    }
  }

  .product-body {
    padding-left: 56px;
    margin-top: 12px;

    &.disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  .option-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .option-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 1px solid var(--seed-scale-color-gray-300);
    border-radius: 10px;
    cursor: pointer;
    box-sizing: content-box;

    &.disabled {
      opacity: 0.4;
      cursor: not-allowed;
      pointer-events: none;
    }

    &.selected {
      border-color: var(--seed-scale-color-gray-900);
      border-width: 2px;
      box-sizing: content-box;
    }

    .option-radio {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 2px solid var(--seed-scale-color-gray-400);
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;
      box-sizing: content-box;


      &.selected {
        background-color: var(--seed-scale-color-gray-900);
        border-color: var(--seed-scale-color-gray-900);

        &::after {
          content: '';
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background-color: white;
        }
      }
    }

    .option-info {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .option-name {
        font-size: 14px;
        color: var(--seed-scale-color-gray-900);
      }

      .option-price {
        font-size: 13px;
        font-weight: 700;
        color: var(--seed-scale-color-gray-900);

        &.no-price {
          color: var(--seed-scale-color-gray-500);
          font-weight: 400;
        }
      }
    }
  }

  .quantity-stepper {
    display: inline-flex;
    align-items: center;

    .stepper-button {
      width: 32px;
      height: 32px;
      border: 1px solid var(--seed-scale-color-gray-300);
      background: var(--seed-semantic-color-paper-default);
      font-size: 16px;
      color: var(--seed-scale-color-gray-600);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:first-of-type {
        border-radius: 4px 0 0 4px;
      }

      &:last-of-type {
        border-radius: 0 4px 4px 0;
      }

      &:hover:not(:disabled) {
        background-color: var(--seed-scale-color-gray-100);
      }

      &:disabled {
        color: var(--seed-scale-color-gray-300);
        cursor: not-allowed;
      }
    }

    .stepper-value {
      width: 40px;
      height: 32px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: var(--seed-scale-color-gray-900);
      border-top: 1px solid var(--seed-scale-color-gray-300);
      border-bottom: 1px solid var(--seed-scale-color-gray-300);
      line-height: 32px;
    }
  }

  .delivery-fee-section {
    margin-top: 12px;
  }

  .delivery-fee-check {
    display: flex;
    align-items: center;
    gap: 8px;

    input[type='checkbox'] {
      width: 20px;
      height: 20px;
      accent-color: var(--seed-scale-color-gray-900);
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }
    }

    label {
      font-size: 14px;
      color: var(--seed-scale-color-gray-900);
      cursor: pointer;
    }
  }

  .delivery-fee-options {
    display: flex;
    flex-wrap: wrap;
    gap: 2px 16px;
    margin-top: 12px;

    .delivery-fee-option {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      .delivery-fee-radio {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid var(--seed-scale-color-gray-400);
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        box-sizing: content-box;

        &.selected {
          background-color: var(--seed-scale-color-gray-900);
          border-color: var(--seed-scale-color-gray-900);

          &::after {
            content: '';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: white;
          }
        }
      }


      span {
        font-size: 14px;
        color: var(--seed-scale-color-gray-900);
      }
    }
  }

  .delivery-fee-amount {
    margin-top: 4px;
    font-size: 14px;
    color: var(--seed-scale-color-gray-600);
  }

  .button-group {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 0 0;
    border-top: 1px solid var(--seed-semantic-color-divider-1);

    .direct-input-button {
      height: 40px;
      padding: 8px 16px;
      border: none;
      border-radius: 6px;
      background: none;
      font-size: 16px;
      font-weight: 600;
      color: var(--seed-scale-color-gray-900);
      background-color: var(--seed-scale-color-gray-100);
      cursor: pointer;

      &:hover {
        background-color: var(--seed-scale-color-gray-200);
      }
    }

    .submit-button {
      height: 40px;
      padding: 8px 16px;
      border: none;
      border-radius: 6px;
      background-color: rgb(42, 48, 56);
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;

      &:hover:not(:disabled) {
        background-color: var(--seed-scale-color-gray-900);
      }

      &:disabled {
        background-color: var(--seed-scale-color-gray-300);
        cursor: not-allowed;
      }
    }
  }
`;
